import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

import { AnalyticsStrings } from "constants/constantStrings";

import AnalyticsCIPCleaningTable from "../AnalyticsCIPCleaningTable";
import { CIP_INDEX_GRAPH_TYPE_DEFAULT, CIPCleaningViews } from "../AnalyticsHelper/Analytics.const";
import { parseCIPCleanigData } from "../AnalyticsHelper/AnalyticsDataParser";

import CIPCleaningHeader from "./CIPCleaningHeader";

const AnalyticsCIPCleaning = ({ xAxisRange, analyticsRawData }) => {
  const [plotType, setPlotType] = useState(CIP_INDEX_GRAPH_TYPE_DEFAULT);
  const [activeView, setActiveView] = useState(CIPCleaningViews.table);
  const [plotData, setPlotData] = useState({});
  const [isCIPEvents, setIsCIPEvents] = useState(false);

  useEffect(() => getData(), [activeView, xAxisRange]);
  useEffect(() => {
    setIsCIPEvents(Boolean(analyticsRawData.CIP_Events.length));
  }, [analyticsRawData.CIP_Events]);

  const getData = () => {
    const { CIP_Events, CIP_Indexes, Time } = analyticsRawData;
    const data = {};
    Object.keys(CIP_Indexes).map(tagKey => {
      const cleanabilityInitial = CIP_Indexes[tagKey]["Cleanability_Intial"];
      data[`${tagKey}_Cleanability_Initial`] = cleanabilityInitial;
    });
    const tagsCleaningIndex = data;
    const xAxisData = CIP_Events.map(event => event.End_Time);
    const [x1, x2] = xAxisRange;
    const range = [x1 || Time[0], x2 || Time[Time.length - 1]];
    if (plotType !== "table") {
      const data = parseCIPCleanigData(plotType, xAxisData, tagsCleaningIndex, range, plotData.Layout);
      setPlotData(data);
    }
  };

  const viewChangeHandler = view => {
    setPlotType(view);
    setActiveView(CIPCleaningViews[view]);
  };

  const onPlotZoom = () => {};
  return (
    <div className="cip-cleaning--container">
      <CIPCleaningHeader onViewChange={viewChangeHandler} isCIPEvents={isCIPEvents} />
      {isCIPEvents ? (
        <>
          {plotType === "table" ? (
            <>
              <AnalyticsCIPCleaningTable analyticsRawData={analyticsRawData} />
              {analyticsRawData && (
                <>
                  <span className="descriptionText note-item displayBlock">
                    {AnalyticsStrings.cipGreen} {AnalyticsStrings.cipValueDescriptionGreen}
                  </span>
                  <span className="descriptionText note-item displayBlock">
                    {AnalyticsStrings.cipOrange} {AnalyticsStrings.cipValueDescriptionYellow}
                  </span>
                  <span className="descriptionText note-item displayBlock">
                    {AnalyticsStrings.cipRed} {AnalyticsStrings.cipValueDescriptionRed}
                  </span>
                  <span className="descriptionText note-item displayBlock">
                    {AnalyticsStrings.cipValueDescriptionGrey}
                  </span>
                  <span className="descriptionText note-item displayBlock"> {AnalyticsStrings.cipValueDescriptionNote}</span>
                </>
              )}
            </>
          ) : (
            <Plot
              className="analytics-cip-index--chart"
              data={plotData?.Data}
              layout={plotData?.Layout}
              useResizeHandler
              scrollZoom
              config={{ displayModeBar: false }}
              style={{ width: "100%", height: "100%" }}
              onRelayout={onPlotZoom}
              onLegendClick={() => false}
              onDoubleClick={() => false}
              onUnhover={e => (e.event.target.style.cursor = "")}
            />
          )}
        </>
      ) : (
        <label className="dupont-form-label">{AnalyticsStrings.noDataMsg}</label>
      )}
    </div>
  );
};

export default AnalyticsCIPCleaning;
